import { useTranslation } from 'react-i18next';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Loader } from 'lucide-react';
import { logger } from '../utils/logger';

const AuthRedirect: React.FC = () => {
  const { t } = useTranslation(['common', 'auth']);
  const { user, isAuthenticated, loading } = useAuth();

  logger.debug('🔄 [AuthRedirect] État:', { isAuthenticated, user: user?.role, loading });

  // Afficher un loader pendant la vérification
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-green-50">
        <div className="text-center">
          <Loader className="animate-spin w-8 h-8 mx-auto mb-4 text-blue-600" />
          <p className="text-slate-600">{t('auth:verification.loading')}</p>
        </div>
      </div>
    );
  }

  // Si authentifié, rediriger selon le rôle
  if (isAuthenticated && user) {
    if (!user.role) {
      logger.warn('⚠️ [AuthRedirect] Rôle manquant - redirection vers login');
      return <Navigate to="/login" replace />;
    }

    const userRole = user.role.toLowerCase();
    let targetPath = `/${userRole}`;
    
    if (['admin', 'saas_admin', 'super_admin'].includes(userRole)) {
      targetPath = '/admin';
    } else if (userRole === 'clinic_manager' || userRole === 'clinic') {
      targetPath = '/clinic';
    } else if (userRole === 'nurse') {
      targetPath = localStorage.getItem('activeClinicId') ? '/clinic/triage' : '/nurse';
    } else if (userRole === 'doctor') {
      const clinicRole = (localStorage.getItem('activeClinicRole') || '').toUpperCase();
      targetPath = (localStorage.getItem('activeClinicId') && clinicRole.includes('CLINIC')) ? '/clinic/triage' : '/doctor';
    }
    
    // Si c'est un nouveau médecin, forcer l'onboarding
    if (userRole === 'doctor' && sessionStorage.getItem('justRegistered') === 'true') {
      targetPath = '/doctor/onboarding';
    }
    
    logger.debug('✅ [AuthRedirect] Utilisateur authentifié, redirection vers:', targetPath);
    return <Navigate to={targetPath} replace />;
  }

  // Si non authentifié, rediriger vers login
  logger.debug('❌ [AuthRedirect] Non authentifié, redirection vers login');
  return <Navigate to="/login" replace />;
};

export default AuthRedirect;
